import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ComboBox } from '@reveni-io/reveni-ui'

import { customMessageTypeLabelKeys } from '../constants'

const MessageTypeSelector = ({ options, value, onChange, disabled, hasError }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const menuItems = options.map(option => ({ value: option, label: t(customMessageTypeLabelKeys[option]) }))

  return (
    <ComboBox
      label={t('Tipo de mensaje')}
      menuItems={menuItems}
      handleChange={onChange}
      value={value || ''}
      fullWidth
      disabled={disabled}
      backgroundColor={disabled ? theme.colors.disabled.surface : theme.colors.background.primary}
      error={hasError}
      helperText={hasError ? t('Este campo es obligatorio') : ' '}
    />
  )
}

export default MessageTypeSelector
